import Vue from 'vue'
import Vuex from 'vuex'
// import { createLogger } from 'vuex/dist/logger'

import notifications from './plugins/notifications'

import app from './modules/app'
import auth from './modules/auth'
import map from './modules/map'
import shareMap from './modules/shareMap'

import incendio from './modules/incendio'
import medio from './modules/medio'
import parametro from './modules/parametro'
import usuario from './modules/usuario'
import simulacion from './modules/simulacion'
import medioPersonal from './modules/medioPersonal'
import infraestructura from './modules/infraestructura'
import equipo from './modules/equipo'
import proveedor from './modules/proveedor'
import dispositivo from './modules/geo_dispositivo'
import informe from './modules/informe'
import personalMedioTipo from './modules/personalMedioTipo'
import personal from './modules/personal'
import demarcacion from './modules/demarcacion'
import estadosMedio from './modules/estadosMedio'
import tituloProfesional from './modules/tituloProfesional'
import personalTipo from './modules/personalTipo'
import organismo from './modules/organismo'
import personalCategoria from './modules/personalCategoria'
import emergencia from './modules/emergencia'

import vuexPersistedstate from 'vuex-persistedstate'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const persistedState = vuexPersistedstate({
  key: 'rioja_app_state',
  reducer: state => ({
    auth: state.auth,
    usuario: state.usuario
  })
})

export default new Vuex.Store({
  modules: {
    app,
    auth,
    map,
    shareMap,

    incendio,
    medio,
    parametro,
    usuario,
    simulacion,
    medioPersonal,
    infraestructura,
    equipo,
    dispositivo,
    proveedor,
    informe,
    personalMedioTipo,
    personalCategoria,
    personal,
    demarcacion,
    estadosMedio,
    tituloProfesional,
    personalTipo,
    organismo,
    emergencia

  },
  plugins: [persistedState, notifications],
  strict: debug
})
